import { Button, type ButtonProperties, Space, Text, Title } from 'ui';

type P = {
  description: string;
  primaryButton: ButtonProperties;
  secondaryButton?: ButtonProperties;
  title: string;
};

const InfoStep = ({ description, primaryButton, secondaryButton, title }: P) => (
  <Space block orientation="vertical" size="xl">
    <Title marginBottom>{title}</Title>
    <Text>{description}</Text>
    <Space block orientation="vertical" size="middle">
      <Button block type="primary" {...primaryButton} />
      {secondaryButton ? <Button block {...secondaryButton} /> : null}
    </Space>
  </Space>
);

export default InfoStep;
